// ABOUTME: Name of the market the tab works in, as the user menu shows it under the user's name.
// ABOUTME: Undefined with the module off or no market available.

import { getMarketSwitcherState } from '../utils/marketSwitcherState';
import { useActiveMarket } from './useActiveMarket';

export function useActiveMarketName(): string | undefined {
    const { marketContext, allowedMarkets } = useActiveMarket();
    const state = getMarketSwitcherState(marketContext);
    if (state.kind !== 'select') return undefined;
    return allowedMarkets.find(market => market.id === state.value)?.name;
}

export default useActiveMarketName;
